export const apiURL = {
  GET_CURRENT_COUNT: `https://api.snackpot.kr/viral/spti/count`,
  SEND_TEST_RESULT: `https://api.snackpot.kr/viral/spti`,
  // SEND_TEST_RESULT: `http://localhost:6495/viral/spti`,
}

export const HTTP_CODE = {
  OK: 202,
  NO_CONTENTS: 204, //성공적으로 처리했지만 컨텐츠를 제공하지는 않는다.
  BAD_REQUEST: 400, // 올바르지 않은 클라이언트 요청 : DB의 FK constraint violation 등
  UNAUTHORIZED: 403, //권한 없음
  NOT_FOUND: 404, //찾는 리소스 없음
  SERVER_ERROR: 500, //서버 오류
}
